import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Initializes i18next before anything renders; must stay above the App import.
import "./i18n";
import { App } from "./App";
import "./styles/main.scss";

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
